import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { View } from '@ds'
import { useHowler } from '@shared'
import { ChapterOverlayData } from '@store'

import styles from './ChapterOverlay.module.scss'

export const ChapterOverlay = ({
  title,
  text,
  onClose,
  soundPhrase,
}: ChapterOverlayData['payload']) => {
  const { t } = useTranslation()
  const { audio } = useHowler({
    src: soundPhrase ?? '',
    volume: 1,
    html5: true,
    preload: true,
  })

  useEffect(() => {
    if (!audio) return

    audio.stop()
    audio.play()

    return () => {
      audio.stop()
    }
  }, [audio])

  return (
    <View fadeIn className={styles.root} onClick={onClose}>
      <div className={styles.body}>
        <div className={styles.mainTitle}>{t(title)}</div>
        <div className={styles.text}>{t(text)}</div>
      </div>
    </View>
  )
}
